export class Ripple {
    public static bind($element: JQuery, selector?: string, animationDurationSec?: number): JQuery {
        return $element.unbind("click.ripple").bind("click.ripple", (evt) => {
            if (evt.isPropagationStopped() || $element.hasClass("loading")) return;

            let btn = $(evt.currentTarget);
            if (selector !== undefined) btn = btn.find(selector);

            const offset = btn.offset();
            if (offset === undefined) return;

            const x = evt.pageX - offset.left;
            const y = evt.pageY - offset.top;

            const duration = animationDurationSec != null ? animationDurationSec * 1000 : 800;
            let animationFrame, animationStart;

            const animationStep = function (timestamp) {
                if (!animationStart) {
                    animationStart = timestamp;
                }

                const frame = timestamp - animationStart;
                if (frame < duration) {
                    const easing = (frame / duration) * (2 - frame / duration);

                    const circle = "circle at " + x + "px " + y + "px";
                    const color = "rgba(0, 0, 0, " + 0.3 * (1 - easing) + ")";
                    const stop = 90 * easing + "%";

                    btn.css({
                        "background-image":
                            "radial-gradient(" + circle + ", " + color + " " + stop + ", transparent " + stop + ")",
                    });

                    animationFrame = window.requestAnimationFrame(animationStep);
                } else {
                    $(btn).css({
                        "background-image": "none",
                    });
                    window.cancelAnimationFrame(animationFrame);
                }
            };

            animationFrame = window.requestAnimationFrame(animationStep);
        });
    }

    public static bindRippleOut($element: JQuery, selector?: string, intensity?: number): JQuery {
        if (intensity === undefined) intensity = 0.5;

        return $element.unbind("click.ripple").bind("click.ripple", (evt) => {
            if (evt.isPropagationStopped() || $element.hasClass("loading")) return;

            const btn = selector !== undefined ? $(evt.currentTarget).find(selector) : $(evt.currentTarget);
            const duration = 600;
            let animationFrame, animationStart;

            const animationStep = function (timestamp) {
                if (!animationStart) {
                    animationStart = timestamp;
                }

                const frame = timestamp - animationStart;
                if (frame < duration) {
                    const easing = (frame / duration) * (2 - frame / duration);
                    const color = "rgba(73, 73, 73, " + intensity! * (1 - easing) + ")";
                    const size = 20 * easing;

                    btn.css({
                        "box-shadow": "0px 0px " + size + "px 1px " + color,
                    });

                    animationFrame = window.requestAnimationFrame(animationStep);
                } else {
                    $(btn).css({
                        "box-shadow": "none",
                    });
                    window.cancelAnimationFrame(animationFrame);
                }
            };

            animationFrame = window.requestAnimationFrame(animationStep);
        });
    }

    public static unbind($element: JQuery): JQuery {
        return $element.unbind("click.ripple");
    }
}
